import React from "react";
import { Helmet } from "react-helmet";

import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import HeaderThree from "../../../components/header/HeaderThree";
import FancyTextBlockThree from "../../../components/fancy-text-block/FancyTextBlockThree";
import AboutTabs from "../../../components/block-slider/AboutTabs";
import FancyBlock from "../../../components/e-commerce/FancyBlock";
import Banner from "../../../assets/Sub-component/Banner";
import { Link } from "react-router-dom";

import Adaptive_Feedback from "../../../assets/Services/Simx/KEY_feature/Adaptive_Feedback.svg";
import Community_Engagement from "../../../assets/Services/Simx/KEY_feature/Community_Engagement.svg";
import Human_Powered_AI from "../../../assets/Services/Simx/KEY_feature/Human_Powered_AI.svg";
import Immersive_Simulations from "../../../assets/Services/Simx/KEY_feature/Immersive_Simulations.svg";
import Interactive_Learning from "../../../assets/Services/Simx/KEY_feature/Interactive_Learning.svg";
import Multidisciplinary_Approach from "../../../assets/Services/Simx/KEY_feature/Multidisciplinary_Approach.svg";
import launchingimage from '../../../assets/Launchingimage.png'

const RaidenSimx = () => {
  const benefits = [
    {
      name: "Choose Your Path",
      value:
        " Incorporate practical training programs and produce original content that meets your company's requirements.",
      name2: "Learn by Doing",
      value2:
        " Experience-based learning is facilitated when real-world scenarios are portrayed in virtual environments.",
      name3: "Track your progress",
      value3:
        "Monitor your development, assess your successes, and modify your learning trajectory for best results",
    },
  ];

  const keyfeature = [
    {
      name: "Immersive Simulations",
      icon: Immersive_Simulations,
      description:
        "Experience learning in authentic, scenario-based settings that go beyond conventional approaches by involving users in practical application.",
      name2: "Human Powered AI",
      icon2: Human_Powered_AI,
      description2:
        "We combine AI with human insight to provide genuinely customized learning experiences that adjust to your preferences and objectives.",

      name3: "Interactive Learning",
      icon3: Interactive_Learning,
      description3:
        "We help you develop your critical thinking skills by providing you with practical experience and teaching you problem-solving techniques.",

      name4: "Adaptive Feedback",
      icon4: Adaptive_Feedback,
      description4:
        "We communicate with you, pay attention to your issues, and offer solutions that support the expansion of your company.",

      name5: "Community Engagement",
      icon5: Community_Engagement,
      description5:
        "As you learn more, interact with our experienced team of professionals who will guide and assist you.",

      name6: "Multidisciplinary Approach",
      icon6: Multidisciplinary_Approach,
      description6:
        "Gain knowledge in several areas and enroll in a training course that suits your interests and goals.",
    },
  ];

  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  return (
    <>
    <img 
  src={launchingimage} 
  className="Bg-image z-0"
  alt="Launching"
/>

    <div className=" overflow-hidden ">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div className="bg-white">
        <div
          className=" container   d-flex align-items-center justify-content-center flex-column  "
          style={{ minHeight: "100vh",position:'relative'}}
        >
          <h1 className="h1-heading fw-bold text-center">Raiden Simx</h1>
          <h2 className="my-2 h2-heading lh-base pt-1">
            {" "}
            Leading the Industry with smart Learning Solutions
          </h2>
          <p className="h1-para text-center mt-4 mb-4">
            Our intelligent learning solutions enable the workforce to innovate,
            adapt, and propel your industry forward.
          </p>
          <Link to="/request-quote">
            <button
              className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
              style={{ fontSize: 18 }}
            >
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>
      <div className=" bg-light">
        <div className=" container pt-50">
          <div className=" row ">
            <h2 className="h2-heading text-center text-lg-start col-12 col-lg-6  ">
              {" "}
              WHY Raiden Simx
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0">
              Our team, which is enthusiastic and well-versed in AI, education,
              and simulation, investigates cutting-edge strategies to
              revolutionize education and help individuals and institutions
              thrive in the face of constant change.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <div className="fancy-text-block-three bg-light mt-80 mart">
          <div className="container">
            <h2 className="text-center h2-heading mb-3 pb-lg-3">
              Key Features
            </h2>
         
            <div className="row">
              <div className="col-xl-11 m-auto">
                <FancyTextBlockThree keyfeature={keyfeature[0]} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-black">
        <div className=" container  pt-80 padt pb-80 padb">
          <div className=" row ">
            <h2 className="h2-heading  text-white text-lg-start col-12 col-lg-6  " style={{marginTop:'26px'}}>
              {" "}
              WHAT WE DO
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0 text-white opacity-75"style={{marginBottom:'80px'}}>
              With AI-powered, realistic simulations adapted by human knowledge,
              we transform training and enable people and businesses to succeed
              in any sector.
            </p>
          </div>
        </div>
      </div>

      {/* How It Works  */}
      <div className="fancy-feature-fortyFou lg-containe mt-80 mart">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-7 m-auto">
              <div className=" text-center ">
                <h2 className="mb-3 pb-lg-2 h2-heading">Industry Domains</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <FancyBlock />
          </div>
        </div>
      </div>

      {/* Who Stands to Gain  */}
      <div className="fancy-text-block-twenty pt-80 padt pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="">
                <h2 className="h2-heading text-center text-lg-start mb-2 mb-lg-0">
                  How It Works
                </h2>
              </div>
            </div>
            <div className="col-lg-6 ms-auto">
              <AboutTabs benefits={benefits[0]} />
            </div>
          </div>
        </div>
      </div>

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      {/* footer */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>

        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
          {/*  /.bottom-footer */}
        </div>
      </footer>
    </div>
    </>
  );
};

export default RaidenSimx;
